import { FPageBlock, FPageBubbleKind } from '../../mdl/f-page-block';
import { UIInputAdapter } from '../../ui/component/adapter';
import { UIButton } from '../../ui/component/button';
import { UILabeled } from '../../ui/component/labeled';
import { hLine } from '../../ui/component/line';
import { UIList } from '../../ui/component/list';
import { UISelect } from '../../ui/component/select';
import { $el } from '../../ui/elements';
import { uiSetPrefixedClass } from '../../ui/functions';
import { UIValue } from '../../ui/types';
import { UIViewSpec } from '../../ui/view';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { YI18NString } from '../../y/i18n';
import { EDBlock, EDBlockSpec } from '../block';
import { EDContainerBlock } from '../containerblock';
import { EDBlockContainer, EDButtonSpec } from '../editor';
import { EDSymbolInput } from '../image';
import { EDI18NInput } from '../input';
import { $page_values } from './values';

const bubble_kind_values: UIValue<FPageBubbleKind>[] = [{ key: 'default', name: 'Default' }, { key: 'white', name: 'White' }];

export const ed_page_bubble_block: EDBlockSpec<FPageBlock> = {
    key: 'bubble',
    editor_block: class extends EDContainerBlock<FPageBlock> {
        constructor(container: EDBlockContainer) {
            const sym = $el.DIV('sym');
            const kind = new UISelect(bubble_kind_values, { kind: 'k-subtle' });
            const symbol = new EDSymbolInput(sym);
            const align = new UISelect($page_values.split_align, { kind: 'k-subtle' });

            const properties = $el.DIV('l-form', [
                new UILabeled(kind, { above: 'Kind' }),
                new UILabeled(symbol, { above: 'Symbol' }),
                new UILabeled(align, { above: 'Align' }),
            ]);

            super($form({ kind, symbol, align }), container, 'Bubble', properties);
            this.classList.add('blk-bubble', 'b', 'b-content')
            this.list.classList.add('o-bubble', 'm-shadow', 'm-top-arrow');
            this.ui_add([sym, this.list])

            $on(kind, 'value', v => {
                uiSetPrefixedClass(this, 'k', v);
            });

            $on(align, 'value', v => {
                uiSetPrefixedClass(this, 'm-align', v);
            });
        }

        override getButtons(): EDButtonSpec[] {
            return [...super.getButtons(), ...this.parent.getChildButtons(this)];
        }
    }
};

export const ed_page_hline_block: EDBlockSpec<FPageBlock> = {
    key: 'hline',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            super($form({}), container, 'Horizontal line', undefined, hLine());
        }
    }
};

export const ed_page_table_block: EDBlockSpec<FPageBlock> = {
    key: 'table',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            const header = new UIInputAdapter<YI18NString>(() => {
                const editable = new EDI18NInput({ tag: 'th', styleable: true, placeholder: 'Type here', classes: 'blk-table-th' });
                return { view: editable, input: editable };
            });

            const rows = new UIInputAdapter<YI18NString[], UIViewSpec, UIInputAdapter<YI18NString>>(() => {
                const cells = new UIInputAdapter<YI18NString>(() => {
                    const editable = new EDI18NInput({ tag: 'td', styleable: true, placeholder: 'Type here', classes: 'blk-table-td' });
                    return { view: editable, input: editable };
                });
                const list = new UIList(cells, { tag: 'tr', classes: 'blk-table-tr' });
                return { view: list, input: cells }
            });

            const add_row = new UIButton({
                title: 'Add row', kind: 'k-text', on_click: () => {
                    const row: YI18NString[] = [];
                    for(let i = 0; i < header.value.length; i++) {
                        row.push({});
                    }
                    rows.push(row);
                }
            });

            const add_column = new UIButton({
                title: 'Add column', kind: 'k-text', on_click: () => {
                    header.push({});
                    for(const row of rows.inputs) {
                        row?.push({});
                    }
                }
            });

            const header_list = new UIList(header, { tag: 'tr', classes: 'blk-table-tr' });
            const rows_list = new UIList(rows, { tag: 'tbody' });

            const properties = $el.DIV('l-form', [add_row, add_column]);

            super($form({ header, rows }), container, 'Table', properties);

            this.classList.add('blk-table', 'b', 'b-content', 'w-hug');

            this.ui_add($el.create('table', 'blk-table-table', [
                $el.create('thead', undefined, header_list),
                rows_list
            ]));
        }
    }
};